import { render, staticRenderFns } from "./ConfirmEmailSend.vue?vue&type=template&id=ddfde454"
import script from "./ConfirmEmailSend.vue?vue&type=script&lang=ts"
export * from "./ConfirmEmailSend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports